export const ranges = [ 1, 5, 10, 20, 50 ]